<template>
    <li>
        <a
            href="javascript:void(0)"
            :title="tagName"
            @click.prevent="tagFiltering"
        >
            #{{ tagName }}
        </a>
    </li>
</template>

<script>
export default {
    props: {
        tag: { type: Object|String },
        theme: { type: String, default: '' }
    },
    computed: {
        tagName(){
            return this.isNotEmptyProp(this.tag, 'name')?this.tag.name.en:this.tag;
        },
    },
    methods:{
        tagFiltering(){
            if( this.theme.length > 0 ){
                window.location.href = `/${this.theme}/search?tag=${this.tagName}`;
            }else{
                console.error('테마가 없음');
                // [TODO] 
            }
        },
    },
}
</script>
